import { render, staticRenderFns } from "./unauthorizedPage.vue?vue&type=template&id=296fb8cf&scoped=true&"
import script from "./unauthorizedPage.vue?vue&type=script&lang=js&"
export * from "./unauthorizedPage.vue?vue&type=script&lang=js&"
import style0 from "./unauthorizedPage.vue?vue&type=style&index=0&id=296fb8cf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296fb8cf",
  null
  
)

export default component.exports